const dict = {
  close: 'close',
  vnAirCaterers: 'vnAirCaterers',
  vietnamAirlinesCaterers: 'vietnamAirlinesCaterers',
  longThanh: 'longThanh',
  longThanhAirport: 'longThanhAirport',
  getQuote: 'getQuote',
  getInTouch: 'getInTouch',
  contactUs: 'contactUs',
  trustedBy: 'trustedBy',
  ourClients: 'ourClients',
  ourClientsText: 'ourClientsText',
  trustedByText: 'trustedByText',
  firstName: 'firstName',
  lastName: 'lastName',

  //hero
  premiumOnAirText: 'premiumOnAirText',
  mealSolutionText: 'mealSolutionText',
  bookSiteTourText: 'bookSiteTourText',
  seeSampleMenu: 'seeSampleMenu',
  ourFourRights: 'ourFourRights',

  //facilitites
  facilityConstructionProgress: 'facilityConstructionProgress',
  siteArea: 'siteArea',
  grossFloorArea: 'grossFloorArea',
  basement: 'basement',
  firstFloor: 'firstFloor',
  secondFloor: 'secondFloor',
  thirdFloor: 'thirdFloor',
  kitchenLayout: 'kitchenLayout',
  tumAndRoof: 'tumAndRoof',
  qaLab: 'qaLab',
  waterWasteTreatment: 'waterWasteTreatment',
  separatedHalalKitchen: 'separatedHalalKitchen',
  yes: 'yes',
  longthanhInfra: 'longthanhInfra',
  longthanhInfraText: 'longthanhInfraText',
  certStandards: 'certStandards',
  squareMeter: 'squareMeter',

  //footer
  allRightsReserve: 'allRightsReserve',

  //menu
  sampleMenu: 'sampleMenu',

  //galery

  //news
  news: 'news',
  annoucement: 'annoucement',
  newsAnnouncement: 'newsAnnouncement',
  progress: 'progress',
  readMore: 'readMore',
  viewAll: 'viewAll',

  //contactUs
  contactSales: 'contactSales',
  contactUsText: 'contactUsText',
  companyAirline: 'companyAirline',
  contactEmail: 'contactEmail',
  phoneNumber: 'phoneNumber',
  requirementText: 'requirementText',
  message: 'message',
  sendRequest: 'sendRequest',
  orContactHotline: 'orContactHotline',

  //menu
  getInTouchWithUs: 'getInTouchWithUs',
  aboutUs: 'aboutUs',
  features: 'features',
  newsMedia: 'newsMedia',
  careerInLongThanh: 'careerInLongThanh',
  ourValueText: 'ourValueText',
  willAchieveBy: 'willAchieveBy',
  newsAnnoucementText: 'newsAnnoucementText',
  getInTouchText: 'getInTouchText',
  careerText: 'careerText',
  ourProcessText: 'ourProcessText',

  //Different
  vacsDifferent: 'vacsDifferent',
  ourPeople: 'ourPeople',
  sustainability: 'sustainability',
  serviceExcellent: 'serviceExcellent',
  safety: 'safety',

  //equipment
  equipment: 'equipment',
  motorVehicle: 'motorVehicle',
  dishwasher: 'dishwasher',
  functionArea: 'functionArea',
  refrigerator: 'refrigerator',
  learnmore: 'learnmore',
  motorVehicleText: 'motorVehicleText',
  dishwasherText: 'dishwasherText',
  functionAreaText: 'functionAreaText',
  refrigeratorText: 'refrigeratorText',

  //stats features
  whyChooseUs: 'whyChooseUs',
  whyChooseUsText: 'whyChooseUsText',
  designedCapacity: 'designedCapacity',
  distanceToStands: 'distanceToStands',
  distanceToRamp: 'distanceToRamp',
  mealPerDay: 'mealPerDay',
  minHiLoader: 'minHiLoader',
  onTimeAccuracy: 'onTimeAccuracy',
  onTimeForFlight: 'onTimeForFlight',
  onTimeForFlightText: 'onTimeForFlightText',
  footSafetyFirst: 'footSafetyFirst',
  footSafetyFirstText: 'footSafetyFirstText',
  flexibleMenu: 'flexibleMenu',
  flexibleMenuText: 'flexibleMenuText',
  digitalOperations: 'digitalOperations',
  digitalOperationsText: 'digitalOperationsText',

  //services
  ourServices: 'ourServices',
  inflightCatering: 'inflightCatering',
  laundry: 'laundry',
  newspaperHandling: 'newspaperHandling',
  storageService: 'storageService',
  logisticService: 'logisticService',
  specialCustomerRequirements: 'specialCustomerRequirements',

  //SampleMenus
  shortHaul: 'shortHaul',
  mediumHaul: 'mediumHaul',
  longHaul: 'longHaul',
  domestic: 'domestic',
  international: 'international',

  //award
  cert: 'cert',
  awardsAccreditations: 'awardsAccreditations',
  awardsAccreditationsText: 'awardsAccreditationsText',
  view: 'view',

  //notFound
  pageNotFound: 'pageNotFound',
  pageNotFoundText: 'pageNotFoundText',
  backPrev: 'backPrev',
  backHome: 'backHome',
  back: 'back',

  name: 'name',
  quantity: 'quantity',
  brand: 'brand',
  purchaseYear: 'purchaseYear',
  function: 'function',
  capacity: 'capacity',
  size: 'size',
  lastestNews: 'lastestNews',

  //navbar
  ourValue: 'ourValue',
  missionVision: 'missionVision',
  ourTeam: 'ourTeam',
  ourProcess: 'ourProcess',
  services: 'services',
  recruitmentActivities: 'recruitmentActivities',
  training: 'training',
  trainingPolicy: 'trainingPolicy',
  ourPurpose: 'ourPurpose',
  mediaGallery: 'mediaGallery',
  investmentPurchasing: 'investmentPurchasing',
  openMenu: 'openMenu',
  closeMenu: 'closeMenu',

  link: 'link',
  segregatedHalalKitchen: 'segregatedHalalKitchen',
  quickView: 'quickView',
  kitchen: 'kitchen',

  noDataAvailable: 'noDataAvailable',
  linkNotValid: 'linkNotValid',
  noPostFound: 'noPostFound',
  technical: 'technical',

  generalDirector: 'generalDirector',
  facility: 'facility',
  facilities: 'facilities',
  career: 'career',
  workWithUs: 'workWithUs',
  beAPartofSomethingBig: 'beAPartofSomethingBig',
  ourStory: 'ourStory',
  ourOpenRoles: 'ourOpenRoles',
  perMonth: 'perMonth',

  achievements: 'achievements',
  viewMore: 'viewMore',
};

export default dict;
